import React, { useState } from 'react';
import { Drawer, Box, List, ListItemButton, ListItemIcon, ListItemText, Icon, IconButton } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { getLocalValue, IsSmallScreen, LoacalVariables } from '../../commonFunctions/CommonFunctions';
import { getMenu } from './menu';
import logoImage from '../../images/logo.svg'
interface MenuItem {
  id: number;
  label: string;
  path?: string;
  icon: React.ElementType;
  children?: MenuItem[];
}

interface SidebarProps {
  isCollapsed: boolean;
  sx?: object;
}

const Sidebar: React.FC<SidebarProps> = ({ isCollapsed, sx }) => {
  const userType: any = "admin" //|| getLocalValue(LoacalVariables.UserType);
  const [openChildMenus, setOpenChildMenus] = useState<Record<number, boolean>>({});
  const [hoveredMenuId, setHoveredMenuId] = useState<number | null>(null);
  const [screenHeight, setScreenHeight] = useState(window.outerHeight);
  const location = useLocation();  // Get the current location from React Router
  const navigate = useNavigate();
  const isMobile = IsSmallScreen();

  const handleToggleChildMenu = (id: number) => {
    setOpenChildMenus((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleMouseEnter = (id: number) => {
    if (isCollapsed) {
      setHoveredMenuId(id);
    }
  };

  const handleMouseLeave = () => {
    setHoveredMenuId(null);
  };

  const menu = getMenu(userType);

  // Helper function to determine if the menu item is selected
  const isSelected = (path?: string) => {
    return path && location.pathname === path;
  };

  const renderMenu = (menuItem: MenuItem) => (
    <li
      key={menuItem.id}
      onMouseEnter={() => handleMouseEnter(menuItem.id)}
      onMouseLeave={handleMouseLeave}
      style={{ position: 'relative' }}
    >
      <ListItemButton
        component={Link}
        to={menuItem.path || '#'}
        onClick={() => menuItem.children && handleToggleChildMenu(menuItem.id)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          padding: '8px 16px',
          backgroundColor: isSelected(menuItem.path) ? '#273142' : 'transparent', // Change background if selected
          color: isSelected(menuItem.path) ? '#fff' : '#bdbdbd', // Change text color if selected
          '&:hover': {
            backgroundColor: isSelected(menuItem.path) ? '#273142' : '#273142', // Keep the same color on hover if selected
          },
        }}
      >
        {((!isMobile && isCollapsed) || (!isMobile && !isCollapsed) || (isMobile && !isCollapsed)) && (
          <ListItemIcon>
            <menuItem.icon sx={{ color: isSelected(menuItem.path) ? '#fff' : '#bdbdbd' }} />
          </ListItemIcon>
        )}
        {!isCollapsed && (
          <ListItemText
            primary={menuItem.label}
            sx={{
              '& .MuiTypography-root': {
                fontSize: '0.875rem',
                marginLeft: -2,
              },
            }}
          />
        )}
        {menuItem.children && (
          <ListItemIcon sx={{ marginLeft: 'auto' }}>
            {!openChildMenus[menuItem.id] ? (
              <ExpandLessIcon sx={{ color: '#fff', display: isCollapsed ? 'none' : '' }} />
            ) : (
              <ExpandMoreIcon sx={{ color: '#fff', display: isCollapsed ? 'none' : '' }} />
            )}
          </ListItemIcon>
        )}
      </ListItemButton>

      {menuItem.children && !isCollapsed && (
        <ul className="child-menu" style={{
          transition: 'max-height 0.3s ease-out',
          overflow: 'hidden',
          maxHeight: openChildMenus[menuItem.id] ? '500px' : '0',
          paddingLeft: '0px',
        }}>
          {menuItem.children.map((child) => (
            <li key={child.id} style={{ listStyle: 'none', paddingLeft: 40 }}>
              <ListItemButton
                onClick={() => child.path && navigate(child.path)}
                sx={{
                  paddingLeft: '24px',
                //  padding: '8px',
                  backgroundColor: isSelected(child.path) ? '#273142' : 'transparent',
                  color: isSelected(child.path) ? '#fff' : '#bdbdbd',
                  '&:hover': {
                    backgroundColor: '#273142',
                  },
                }}
              >
                <ListItemText
                  primary={child.label}
                  sx={{ '& .MuiTypography-root': { fontSize: '0.875rem' } }}
                />
              </ListItemButton>
            </li>
          ))}
        </ul>
      )}
    </li>
  );

  return (
    <Drawer
      variant="persistent"
      open={!isCollapsed}
      sx={{
        width: !isCollapsed ? 220 : 0,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: 220,
          transition: 'transform 0.3s ease-in-out', // Smooth transition for opening/closing
          transform: isCollapsed ? 'translateX(-100%)' : 'translateX(0)',  // Sidebar sliding effect
          boxShadow: '4px 0 6px #3F4D67', // Shadow effect on the right side
          ...sx,
        },
      }}
    >
      <Box
        sx={{
          height: 200,
          backgroundColor: '#3F4D67',
          color: '#fff',
          transition: 'width 0.3s ease',
          position: 'relative',
          display: 'flex', // Enable flexbox
          justifyContent: 'center', // Center the image horizontally
          alignItems: 'center', // Center the image vertically
        }}
      >
        <img
          src={logoImage}
          alt="Illustration"
          width={130}
        />
      </Box>

      <Box
        sx={{
          height: screenHeight ? screenHeight + 1000 : 'auto',
          backgroundColor: '#3F4D67',
          color: '#fff',
          transition: 'width 0.3s ease',
          position: 'relative',
        }}
      >
        {((!isMobile && isCollapsed) || (!isMobile && !isCollapsed) || (isMobile && !isCollapsed)) && (
          <List component="ul">
            {menu.staticMenu.map((menuItem: MenuItem) => renderMenu(menuItem))}
          </List>
        )}
      </Box>
    </Drawer>

  );
};

export default Sidebar;
